/** Sales infra API — repos, helpers de infra y tipos de infra. */

export {
  displayPaymentMethodLabel,
  buildPaymentMethodNames,
  DEFAULT_PAYMENT_METHOD_LABELS,
} from './infra/salesPaymentLabels';

export { SALE_IS_ACTIVE } from './infra/salesRepoSql';

export {
  DATE_RANGE_PRESET_LABELS,
  DATE_RANGE_PRESETS,
  POS_SALES_HISTORY_DATE_PRESETS,
  type DateRangePreset,
} from './infra/salesReportingConstants';

export {
  formatLocalYmd,
  getSalesDateRange,
  getSalesDateRangeLabel,
  getLocalYmdRangeFromPreset,
  matchPosSalesHistoryDatePreset,
  ymdToStartIso,
  ymdToEndIso,
  isSalesTimeBandsApplicable,
  getPreviousHomologousPeriod,
  startOfWeekMondayLocal,
  type ReportsCustomRange,
  type ReportsDateRange,
} from './infra/salesDateRange';

export {
  SALES_LIST_PAGE_SIZE_OPTIONS,
  SALES_LIST_PAGE_SIZE,
  type SalesListPageSize,
} from './infra/salesList.constants';

export {
  saleRowMatchesPaymentPendingFilter,
  salesListPaymentPendingSqlClause,
} from './infra/salesListFilters';

export { deriveCustomerPendingAmount, deriveSalePaymentStatus } from './infra/salePaymentStatus';

export {
  createSale,
  voidSale,
  getPaymentMethods,
  getStockWarnings,
  listSales,
  countSales,
  getSaleDetail,
  getSalePaymentTotals,
  getCustomerNameById,
  getTodaySalesSnapshot,
  getSalesByTimeBand,
  getSalesComparison,
  getSalesSnapshotByDateRange,
  getSalesSnapshotByDateRangeWithVentasScope,
  getPromotionPerformanceByDateRange,
  getSalesTimeBandWindows,
  computeSalePaidPendingAmounts,
  CASHIER_LIST_FILTER_NULL,
  PromotionPerformanceUnavailableError,
  PROMOTION_PERFORMANCE_UNAVAILABLE_CODE,
} from './infra/salesRepo';

export type {
  FiscalMode,
  FiscalBuyerSyncFields,
  PaymentMethodRow,
  SaleItemInput,
  SalePaymentInput,
  SaleDiscountInput,
  SaleStatus,
  StockWarningDetail,
  StockWarningsResult,
  TimeBand,
  SalesByTimeBandRow,
  SalesComparison,
  SalesByCashierRow,
  SalesSnapshot,
  PromotionPerformanceRow,
  PromotionPerformanceSnapshot,
} from './infra/salesRepo';

export {
  recalculateSalePaymentStatus,
} from './infra/salePaymentStatusRecalc';

export {
  saveSaleAttachment,
  listSaleAttachments,
  deleteSaleAttachment,
  createSaleAttachmentUrl,
  type SaleAttachmentRow,
} from './infra/saleAttachmentsRepo';

export {
  invalidateBranchSalesListCaches,
  invalidateSaleDetailCache,
  invalidateSalesListCachesForSale,
} from './infra/salesListInvalidation';

export { buildSalesListCsv } from './infra/salesListCsv';

export {
  fetchAllSalesListRowsForExport,
  SALES_LIST_EXPORT_MAX_ROWS,
} from './infra/salesListExport';
